//export var apiUrl: string = 'https://staging.pipeline.page/api';
export var apiUrl: string = 'https://api-services.dpolg.app/api';
export var hostUrl: string = 'https://api-services.dpolg.app';
export var proxyPrefix: string = apiUrl + '/searchengine/proxy.json?format=json&url=';

export var pipelineAppConfig: pipelineAppConfig = {
    allowUserCreateChat: true,
    allowUserCreateChatGroup: true,
    allowUserEditPostSettings: false,
    allowUserForgotPassword: false,
    allowUserLogin: true,
    allowUserPostContent: false,
    allowUserPostContentAsCreator: true,
    allowUserPostContentAsGuest: false,
    allowUserPostContentAsUser: false,
    allowUserRegister: true,
    allowUserTranslatePost: false,
    allowUserWriteChatMessage: true,
    appDescription: 'Creator Studio',
    appId: 'page.pipeline.creators',
    appName: 'Creator Studio',
    appPackageName: 'pipeline-creator-studio',
    appPages: {
        
        ai_training: [
            {
                allowedUserTypes: ['Admin', 'Moderator', 'Vertrieb'],
                key: "ai_training_log",
                url: "/ai/training/log",
                icon: "pulse-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Moderator', 'Vertrieb'],
                key: "ai_knowledgebase",
                url: "/ai/training/knowledgebase",
                icon: "library-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Moderator', 'Vertrieb'],
                key: "translations_admin",
                url: "/translations",
                icon: "language-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "ai_url_lookup",
                url: "/ai/url-lookup",
                icon: "globe-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['ai', 'editors', 'enterprise'],
            },
        ],

        content_hub: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "content_hub",
                url: "/posts-admin",
                icon: "document-text-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['basic', 'pro', 'enterprise'],
            },
            /*
            {
                allowedUserTypes: ['Admin', 'Moderator', 'Vertrieb'],
                key: "newsletters",
                url: "/newsletters",
                icon: "newspaper-outline",
                hideIfLoggedOut: true,
            },
            */
            {
                allowedUserTypes: ['Admin', 'Moderator', 'Vertrieb'],
                key: "surveys",
                url: "/surveys",
                icon: "receipt-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['surveys', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Moderator', 'Vertrieb'],
                key: "quizzes_admin",
                url: "/quizzes",
                icon: "dice-outline",
                hideIfLoggedOut: true,
            },
        ],

        creators_shop_admin: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "creators_shop_admin",
                url: "/sources/shops",
                icon: "storefront-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "shop_products",
                url: "/shop/products",
                icon: "grid-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "shop_categories",
                url: "/shop/categories",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "orders",
                url: "/orders",
                icon: "card-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            }
        ],
        
        integrations: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Moderator', 'Vertrieb'],
                key: "creators_blog_admin",
                url: "/sources/blogs",
                icon: "folder-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "social_media",
                url: "/integrations",
                icon: "share-social-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "creators_shop_admin",
                url: "/sources/shops",
                icon: "storefront-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_facebook: [
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_facebook",
                url: "/integrations/integration/facebook/connections",
                icon: "logo-facebook",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "facebook_api_log",
                url: "/integrations/integration/facebook",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "meta_groups",
                url: "/integrations/integration/meta/groups",
                icon: "people-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_instagram: [
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_instagram",
                url: "/integrations/integration/instagram/connections",
                icon: "logo-instagram",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "instagram_api_log",
                url: "/integrations/integration/instagram",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_linkedin: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_linkedin",
                url: "/integrations/integration/linkedin/connections",
                icon: "logo-linkedin",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "linkedin_api_log",
                url: "/integrations/integration/linkedin",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_pinterest: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_pinterest",
                url: "/integrations/integration/pinterest/connections",
                icon: "logo-pinterest",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "pinterest_api_log",
                url: "/integrations/integration/pinterest",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_reddit: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_reddit",
                url: "/integrations/integration/reddit/connections",
                icon: "logo-reddit",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "reddit_api_log",
                url: "/integrations/integration/reddit",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_snapchat: [
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_snapchat",
                url: "/integrations/integration/snapchat/connections",
                icon: "logo-snapchat",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "snapchat_api_log",
                url: "/integrations/integration/snapchat",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_tiktok: [
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_tiktok",
                url: "/integrations/integration/tiktok/connections",
                icon: "logo-tiktok",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "tiktok_api_log",
                url: "/integrations/integration/tiktok",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_twitch: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_twitch",
                url: "/integrations/integration/twitch/connections",
                icon: "logo-twitch",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "twitch_api_log",
                url: "/integrations/integration/twitch",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_twitter: [
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_twitter",
                url: "/integrations/integration/twitter/connections",
                icon: "logo-twitter",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "twitter_api_log",
                url: "/integrations/integration/twitter",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_whatsapp: [
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_whatsapp",
                url: "/integrations/integration/whatsapp/connections",
                icon: "logo-whatsapp",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "whatsapp_api_log",
                url: "/integrations/integration/whatsapp",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_xing: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_xing",
                url: "/integrations/integration/xing/connections",
                icon: "logo-xing",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "xing_api_log",
                url: "/integrations/integration/xing",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        integration_youtube: [
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_youtube",
                url: "/integrations/integration/youtube/connections",
                icon: "logo-youtube",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "youtube_api_log",
                url: "/integrations/integration/google",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        telegram_bots: [
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "telegram_bots",
                url: "/integrations/integration/telegram/bots",
                icon: "chatbubble-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "telegram_api_log",
                url: "/integrations/integration/telegram",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        main: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "creator_dashboard",
                url: "/creators-dashboard",
                icon: "grid-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['basic', 'pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "database",
                url: "/crud/list/dpolg",
                icon: "server-outline",
                hideIfLoggedOut: true,
            },
            /*
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "ai_search",
                url: "/ai/search",
                icon: "trail-sign-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            */
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "content_hub",
                url: "/posts-admin",
                icon: "document-text-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['basic', 'pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "media",
                url: "/media/library",
                icon: "images-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['basic', 'pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin'],
                key: "groups_admin",
                url: "/groups",
                icon: "people-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            },
            /*
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "campaigns",
                url: "/ai/plans",
                icon: "calendar-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "ai_tasks",
                url: "/ai/tasks",
                icon: "terminal-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['pro', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Moderator', 'Vertrieb'],
                key: "statistics_admin",
                url: "/statistics",
                icon: "trending-up-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['marketing', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "creators_marketplace",
                url: "/marketplace/dashboard",
                icon: "people-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['marketplace', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "creators_shop_admin",
                url: "/sources/shops",
                icon: "storefront-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['shop', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Moderator', 'Vertrieb'],
                key: "ads",
                url: "/ads-admin",
                icon: "megaphone-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['ads', 'enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "websites_admin",
                url: "/creator/websites",
                icon: "desktop-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['websites', 'enterprise'],
            },
            */
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "settings",
                label: 'getgenius_menu_settings',
                url: "/settings",
                icon: "settings-outline",
                hideIfLoggedOut: true,
                children: [
                    {
                        allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                        key: "apps",
                        url: "/whitelabel-apps",
                        icon: "phone-portrait-outline",
                        hideIfLoggedOut: true,
                        requiresAboExtension: ['pro', 'enterprise'],
                    },
                    {
                        allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                        key: "integrations",
                        url: "/integrations",
                        icon: "extension-puzzle-outline",
                        hideIfLoggedOut: true,
                        requiresAboExtension: ['enterprise'],
                    },
                    {
                        allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                        key: "media_templates",
                        url: "/media/templates",
                        icon: "eye-outline",
                        hideIfLoggedOut: true,
                        requiresAboExtension: ['pro', 'enterprise'],
                    },
                    {
                        allowedUserTypes: ['Admin', 'Creator', 'Moderator', 'Vertrieb'],
                        key: "projects_admin",
                        url: "/projects",
                        icon: "briefcase-outline",
                        hideIfLoggedOut: true,
                        requiresAboExtension: ['pro', 'enterprise'],
                    },
                    {
                        allowedUserTypes: ['Admin', 'Moderator'],
                        key: "teams",
                        url: "/teams",
                        icon: "people-circle-outline",
                        hideIfLoggedOut: true,
                        requiresAboExtension: ['pro', 'enterprise'],
                    },
                    {
                        allowedUserTypes: ['Admin'],
                        key: "customers",
                        url: "/customers-admin",
                        icon: "person-outline",
                        hideIfLoggedOut: true,
                        requiresAboExtension: ['pro', 'enterprise'],
                    },
                    {
                        allowedUserTypes: ['Admin'],
                        key: "user_groups_admin",
                        url: "/user-groups",
                        icon: "hand-right-outline",
                        hideIfLoggedOut: true,
                        requiresAboExtension: ['pro', 'enterprise'],
                    },
                ],
            },
        ],
        marketing: [
            
        ],
        meta_connections: [
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_facebook",
                url: "/integrations/integration/facebook/connections",
                icon: "logo-facebook",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_instagram",
                url: "/integrations/integration/instagram/connections",
                icon: "logo-instagram",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_whatsapp",
                url: "/integrations/integration/whatsapp/connections",
                icon: "logo-whatsapp",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "meta_comments",
                url: "/integrations/integration/meta/comments",
                icon: "chatbubble-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "meta_log",
                url: "/integrations/integration/meta/log",
                icon: "list-outline",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        
        social_media: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_linkedin",
                url: "/integrations/integration/linkedin/connections",
                icon: "logo-linkedin",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_pinterest",
                url: "/integrations/integration/pinterest/connections",
                icon: "logo-pinterest",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_reddit",
                url: "/integrations/integration/reddit/connections",
                icon: "logo-reddit",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_snapchat",
                url: "/integrations/integration/snapchat/connections",
                icon: "logo-snapchat",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "meta_connections",
                url: "/integrations/integration/facebook/connections",
                icon: "logo-facebook",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_tiktok",
                url: "/integrations/integration/tiktok/connections",
                icon: "logo-tiktok",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_twitch",
                url: "/integrations/integration/twitch/connections",
                icon: "logo-twitch",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_twitter",
                url: "/integrations/integration/twitter/connections",
                icon: "logo-twitter",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_xing",
                url: "/integrations/integration/xing/connections",
                icon: "logo-xing",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
            {
                allowedUserTypes: ['Admin', 'Redakteur', 'Moderator', 'Vertrieb'],
                key: "integration_youtube",
                url: "/integrations/integration/youtube/connections",
                icon: "logo-youtube",
                hideIfLoggedOut: true,
                requiresAboExtension: ['enterprise'],
            },
        ],
        /*
        statistics_admin: [
            {
                allowedUserTypes: ['Admin', 'Creator', 'Moderator', 'Vertrieb'],
                key: "statistics_admin",
                url: "/statistics",
                icon: "stats-chart-outline",
                hideIfLoggedOut: true,
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Moderator', 'Vertrieb'],
                key: "analytics_admin",
                url: "/analytics-admin",
                icon: "funnel-outline",
                hideIfLoggedOut: true,
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Moderator', 'Vertrieb'],
                key: "statistics_reports",
                url: "/statistics/reports",
                icon: "document-text-outline",
                hideIfLoggedOut: true,
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Moderator', 'Vertrieb'],
                key: "statistics_trends",
                url: "/trends-statistics",
                icon: "flash-outline",
                hideIfLoggedOut: true,
            },
            {
                allowedUserTypes: ['Admin', 'Creator', 'Moderator', 'Vertrieb'],
                key: "statistics_social_media",
                url: "/statistics/social-media",
                icon: "thumbs-up-outline",
                hideIfLoggedOut: true,
            },
        ],
        */
    },
    appSlogan: 'Creator Studio',
    appVersionId: 100905,
    appVersionName: '0.9.5',
    contentHostUrl: 'https://dpolg.app/',
    crud: {
        services: [
            {
                name: 'dpolg',
                tables: [
                    {
                        name: 'Abkürzungen',
                        uid: -1,
                        url: '/crud/list/dpolg/abbreviations',
                    },
                    {
                        name: 'Betäubungsmittel',
                        uid: -1,
                        url: '/crud/list/dpolg/narcotics',
                    },
                    {
                        name: 'Erste Hilfe',
                        uid: -1,
                        url: '/crud/list/dpolg/first_aid',
                    },
                    /*
                    {
                        name: 'fundus_items',
                        uid: -1,
                        url: '/fundus_items',
                    },
                    {
                        name: 'fundus_links',
                        uid: -1,
                        url: '/fundus_links',
                    },
                    */
                    {
                        name: 'Fahrerlaubnis',
                        uid: -1,
                        url: '/crud/list/dpolg/driving_licence',
                    },
                    {
                        name: 'Gefahrstoffe',
                        uid: -1,
                        url: '/crud/list/dpolg/hazardous_substances',
                    },
                    {
                        name: 'Jugendschutz',
                        uid: -1,
                        url: '/crud/list/dpolg/youth_protection',
                    },
                    {
                        name: 'KFZ-Kennzeichen',
                        uid: -1,
                        url: '/crud/list/dpolg/licence_plates',
                    },
                    {
                        name: 'Schichtpläne',
                        uid: -1,
                        url: '/crud/list/dpolg/service_plans',
                    },
                    {
                        name: 'Tatbestandskatalog',
                        uid: -1,
                        url: '/crud/list/dpolg/catalog_of_facts',
                    },
                    {
                        name: 'Verkehrszeichen',
                        uid: -1,
                        url: '/crud/list/dpolg/traffic_signs',
                    },
                    {
                        name: 'Versicherungskennzeichen',
                        uid: -1,
                        url: '/crud/list/dpolg/insurance_traffic_signs',
                    },
                    {
                        name: 'Waffentabelle',
                        uid: -1,
                        url: '/crud/list/dpolg/weapons_table',
                    },
                    {
                        name: 'Waffenübersicht',
                        uid: -1,
                        url: '/crud/list/dpolg/weapons_overview',
                    },
                ],
                uid: 'dpolg',
            }
        ],
    },
    environments: {
        api: {
            local: 'https://api-services.dpolg.local/api',
            production: 'https://api-services.dpolg.app/api',
            staging: 'https://staging.api-services.dpolg.app/api',
            testing: 'https://testing.api-services.dpolg.app/api',
        },
        app: {
            local: 'https://admin.dpolg.local',
            production: 'https://admin.dpolg.app',
            staging: 'https://staging.admin.dpolg.app',
            testing: 'https://testing.admin.dpolg.app',
        }
    },
    filterDiscoverPostsByContentHostUrl: false,
    filterHomePostsByContentHostUrl: true,
    filterLocalPostsByContentHostUrl: false,
    filterPeopleByContentHostUrl: true,
    filterSearchResultsByContentHostUrl: true,
    filterUserByTeamUids: true,
    footerBottomText: `<p>
        Erstellt mit <a href="https://pipeline.page" target="_blank">pipeline</a><br>
        &copy; ${new Date().getFullYear()} pipeline App GmbH<br><br>
        <a href="https://pipeline.page/de/agb" target="_blank">AGB</a><br>
        <a href="https://pipeline.page/de/datenschutz" target="_blank">Datenschutzerklärung</a>
    </p>`,
    forceAbonnementAfterRegistration: true,
    forceProjectToBeSet: true,
    globalCreateItems: [
      {
        icon: 'images-outline',
        name: 'media',
        url: '/media/create',
      },
      {
        icon: 'terminal-outline',
        name: 'ai_task',
        url: '/ai/quick',
      },
      {
        icon: 'cube-outline',
        name: 'group',
        url: '/group',
      },
      {
        icon: 'extension-puzzle-outline',
        name: 'integration',
        url: '/integrations',
      },
      {
        icon: 'text-outline',
        name: 'post',
        url: '/post/new',
      },
      {
        icon: 'briefcase-outline',
        name: 'project',
        url: '/project',
      },
      {
        icon: 'dice-outline',
        name: 'quiz',
        url: '/quiz',
      },
      {
        icon: 'people-circle-outline',
        name: 'team',
        url: '/team',
      },
      {
        icon: 'receipt-outline',
        name: 'survey',
        url: '/survey',
      },
      {
        icon: 'person-outline',
        name: 'user',
        url: '/customer',
      },
    ],
    includeRatingsInFeed: false,
    includeReactionsInFeed: false,
    includeRelatedArticlesInFeed: false,
    isApiURLConfigurable: false,
    isWhitelabel: true,
    links: {
        imprint: 'https://pipeline.page/unternehmen/impressum/',
        privacy_policy: 'https://pipeline.page/datenschutz/',
        terms_of_use: 'https://pipeline.page/agb/',
    },
    loginHeadlineText: 'Creator Studio',
    loginTopLogoSize: 'medium',
    loginTopLogoUrl: './assets/img/logo-dark.webp',
    maxPostAge: 365,
    menuSideDesktop: 'start',
    menuSideMobile: 'start',
    multiLanguageSupport: true,
    multiUser: true,
    orderBy: {
        discover: 'post_date_gmt desc',
        home: 'post_date_gmt desc',
        local: 'post_date_gmt desc',
        people: 'RAND()',
        shop: 'name',
        showroom: 'post_date_gmt desc',
    },
    postsVipFactor: 0,
    pushAppId: 'ac05c119-5059-4f81-b614-7ea965c62afa',
    registerFlow: 'password',
    registerRequiresAbonnement: true,
    routes: {
        discover: '/tabs/shop/discover',
        home: '/creators-dashboard',
        local: '/tabs/local',
        people: '/tabs/people',
        shop: '/tabs/shop-categories-list',
    },
    showAccountBecomeCreator: false,
    showAccountClearCaches: true,
    showAccountSecurity: true,
    showAppearanceColorSchemes: true,
    showAppearanceFontsSelector: false,
    showAppearanceFontSizeSelector: false,
    showAppearancePreferedImageSize: false,
    showAppearanceTabs: true,
    showCheckoutPage: false,
    showFeedBottomShadow: false,
    showFooterAppVersion: true,
    showFooterBottomText: true,
    showGetGeniusDaniInDashboard: true,
    showGetGeniusDaniInSidebar: false,
    showHeaderLargeTitle: true,
    showHeaderMenuButton: true,
    showHeaderToolbarLogo: true,
    showHeaderToolbarLogoInApp: true,
    showHeaderToolbarLogoInWeb: false,
    showHeaderToolbarTitle: false,
    showJobPostsInFeeds: false,
    showJobPostsInSearchResults: false,
    showLocalSourcesSuggestions: false,
    showLoginCredentialsSkipAccount: true,
    showLoginPage: false,
    showLoginPageLeftImg: true,
    showLoginPageLeftImgCase: true,
    showLoginTopLogo: true,
    showLoomaBlanketPurchaseOrders: false,
    showLoomaCustomersPersonTypeOrganization: true,
    showLoomaCustomersPersonTypePerson: true,
    showLoomaOrdersSegmentToolbar: false,
    showLoomaProductionOrders: false,
    showLoomaPurchaseOrders: false,
    showLoomaSalesOrders: true,
    showMenuAddButton: true,
    showMenuGlobalSearch: true,
    showMenuHeaderLogo: true,
    showMenuHeaderTitle: false,
    showMenuIfLoggedOut: false,
    showMenuPagesInApp: true,
    showMenuPagesInWeb: true,
    showPodcastsSuggestions: false,
    showPodcastsSuggestionsInFeed: false,
    showPostAuthorCard: false,
    showPostCardAdminFab: true,
    showPostCardExcerpt: true,
    showPostCardHostLabel: false,
    showPostCardOptions: false,
    showPostCardVerifiedBadges: false,
    showPostPagination: false,
    showPostReadInAppCard: false,
    showPostRelatedArticles: true,
    showProfileDisplayName: true,
    showProfileEvents: false,
    showProfileFriends: false,
    showProfileSocialInformation: false,
    showProfileSocialInformationLabels: false,
    showProfileUserGroup: false,
    showProfileUserGroupAsPrimaryLabel: false,
    showProfileUsername: true,
    showRegisterProjectSettings: false,
    showRegisterVideos: false,
    showSalut: false,
    showSettingsLegalLinks: true,
    showSettingsLinks: true,
    showShopCategories: true,
    showShopNewestProducts: true,
    showShopRelatedProductsOnDetailPage: true,
    showShopSaleProducts: true,
    showShopSources: true,
    showShopSuggestedProducts: true,
    showShopTrendingProducts: true,
    showSuggestedProfilesOnFeedPage: false,
    showSuggestedProfilesOnHomePage: false,
    showSuggestedProfilesOnLocalPage: false,
    showTabBar: true,
    showTabBarAsDock: false,
    showTabBarInMenuOnApp: true,
    showTabBarInMenuOnWeb: true,
    showTabBarLabels: true,
    showTabMenu: false,
    tabBarActiveStyle: 'solid',
    tabs: [
        {
            uid: 'weclapp_connections',
            checked: true,
            icon: 'link-outline',
            indent: 'weclapp_connections',
            index: 0,
            name: 'weclapp_connections',
            route: 'weclapp-connections',
            url: '/tabs/weclapp-connections',
        },
        {
            uid: 'looma_articles',
            checked: true,
            icon: 'storefront-outline',
            indent: 'looma_articles',
            index: 4,
            name: 'articles',
            route: 'looma-articles',
            url: '/tabs/looma-articles',
        },
        {
            uid: 'looma_customers',
            checked: true,
            icon: 'people-outline',
            indent: 'looma_customers',
            index: 1,
            name: 'looma_customers',
            route: 'looma-customers',
            url: '/tabs/looma-customers',
        },
        /*
        {
            uid: 'shopAccount',
            checked: true,
            icon: 'person-outline',
            indent: 'shop-account',
            index: 4,
            name: 'account',
            route: 'shop-account',
            url: '/tabs/shop-account',
        },
        */
        {
            uid: 'looma_offers',
            checked: true,
            icon: 'document-outline',
            indent: 'looma_offers',
            index: 2,
            name: 'looma_offers',
            route: 'looma-offers',
            url: '/tabs/looma-offers',
        },
        {
            uid: 'looma_orders',
            checked: true,
            icon: 'basket-outline',
            indent: 'looma_orders',
            index: 3,
            name: 'salesOrders',
            route: 'looma-orders',
            url: '/tabs/looma-orders',
        },
        {
            uid: 'looma_history',
            checked: true,
            icon: 'list-outline',
            indent: 'looma_history',
            index: 5,
            name: 'history',
            route: 'looma-history',
            url: '/tabs/looma-history',
        },
    ],
    translucentFooters: false,
    translucentHeaders: false,
    useAbonnements: false,
    useAdsExtension: false,
    useAiExtension: true,
    useAppearance: true,
    useAppleWatchExtension: false,
    useArchive: false,
    useAssetsExtension: true,
    useAuthExtension: false,
    useAvatars: false,
    useBionicReadingExtension: true,
    useBlogsExtension: true,
    useCalendar: false,
    useCategories: true,
    useCategoriesOnDiscoverPage: false,
    useCategoriesOnFeedPages: true,
    useCategoriesOnHomePage: true,
    useCategoriesOnLocalPage: false,
    useCategoriesOnSearchPage: true,
    useChatExtension: false,
    useCompaniesExtension: false,
    useCommentsExtension: true,
    useComplexityExtension: false,
    useControlCenterExtension: true,
    useCookiesAlertInApp: false,
    useCookiesAlertInWebApp: true,
    useCouponsExtension: true,
    useCreativesExtension: true,
    useCrudExtension: true,
    useDashboardCardsWizard: true,
    useDashboardGetGeniusSearch: true,
    useDatabaseExtension: true,
    useDatingExtension: false,
    useDeathAnnouncementsExtension: false,
    useDiscover: true,
    useDocumentsExtension: false,
    useEventsList: false,
    useExperiments: false,
    useFeedback: false,
    useFeeds: false,
    useFiltersExtension: false,
    useFollow: false,
    useGetGeniusDashboardAiShortcuts: true,
    useGetGeniusExtension: true,
    useGetGeniusWalletExtension: false,
    useGoogleMapsExtension: false,
    useGroups: false,
    useHeadlineProfileAvatar: true,
    useHelpCenterExtension: false,
    useHome: false,
    useInbox: false,
    useInterests: false,
    useIntro: false,
    useIntroCards: true,
    useIntroPeople: false,
    useIntroReadingSettings: false,
    useInviteFriends: false,
    useJobPosts: false,
    useJobTitlesExtension: false,
    useLocal: false,
    useLoomaExtension: false,
    useMarketplaceExtension: false,
    useMediaExtension: true,
    useMoviesExtension: false,
    useNewsletterExtension: true,
    useOrderByFilters: false,
    usePayPalExtension: false,
    usePeople: false,
    usePointsSystem: false,
    usePostPaywallExtension: false,
    usePostsAdmin: true,
    useProfile: false,
    useProfileDisplayNames: true,
    useProfileTitleExtension: false,
    useProfileUsernames: true,
    useProjectsExtension: true,
    usePushNotifications: true,
    usePushNotificationsChannels: true,
    useQuizExtension: true,
    useReactions: false,
    useRegionSearch: true,
    useRegionSearchSuggestions: false,
    useReportingExtension: false,
    useSearch: false,
    useSecurityExtension: true,
    useSettings: false,
    useSharingExtension: true,
    useShop: false,
    useShopAccount: true,
    useShopCategories: true,
    useShopInternalPaymentProcess: true,
    useShortcuts: false,
    useShowroom: true,
    useSignInWithApple: false,
    useSignInWithFacebook: false,
    useSignInWithGoogle: false,
    useSimplyLocalExtension: false,
    useStatisticsExtension: false,
    useStories: true,
    useStoriesCameraExtension: true,
    useStoriesOnDiscoverPage: true,
    useStoriesOnHomePage: false,
    useStoriesOnLocalPage: false,
    useStoriesOnPeoplePage: true,
    useSurveyExtension: true,
    useTagsExtension: true,
    useTeamsExtension: true,
    useTesting: false,
    useThemes: true,
    useThreeDeeTouch: false,
    useTransparencyExtension: false,
    useTvExtension: false,
    useVideosExtension: true,
    useWallet: false,
    useWebsitesExtension: false,
    useWeclappExtension: false,
    useWeloveWalletExtension: false,
    useWhitelabelAppsExtension: false,
};